<template>
  <v-container grid-list-lg fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>{{$t('pagesSplitBids.view.title')}}</h1>
      </v-flex>
      <v-flex xs12 py-0>
        <v-divider />
      </v-flex>
    </v-layout>
    <span @click="$router.push({ name: 'SplitBids' })" class="goback"
      >{{$t('pagesSplitBids.view.goBack')}}</span
    >

    <v-layout row wrap>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12 pt-0>
            <loading v-if="loading" />
            <div class="block grid-list-lg" v-if="!loading && errors">
              <div v-if="errors">
                <h2 class="empty_title" v-if="errors && errors.length">
                  <v-icon color="error">warning</v-icon>
                  {{$t('pagesSplitBids.view.errorLoading')}} : {{ errors }}
                </h2>
              </div>
            </div>

            <div class="block grid-list-lg" v-if="!loading && !errors">
              <div>
                <div v-if="item">
                  <table class="table-noborder">
                    <tbody>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.list.table.fields.phone')}}</td>
                        <td class="w100">
                          {{ item.user.phone | formatPhone }}
                        </td>
                      </tr>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.list.table.fields.created_at')}}</td>
                        <td class="w100">
                          {{ item.created_at | formatDate }}
                        </td>
                      </tr>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.list.table.fields.tarif')}}</td>
                        <td class="w100">
                          {{ getStatus("tarifList", item.tarif, "name") }}
                        </td>
                      </tr>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.list.table.fields.month')}}</td>
                        <td class="w100">{{ item.month }} мес.</td>
                      </tr>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.list.table.fields.price')}}</td>
                        <td class="w100">
                          {{ item.price | formatPrice }}
                        </td>
                      </tr>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.list.table.fields.percent')}}</td>
                        <td class="w100">{{ item.percent }}%</td>
                      </tr>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.list.table.fields.bonus')}}</td>
                        <td class="w100">
                          {{ item.bonus | formatPrice }}
                        </td>
                      </tr>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.list.table.fields.completed_date')}}</td>
                        <td class="w100">
                          {{ item.completed_date | formatDate }}
                        </td>
                      </tr>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.list.table.fields.payment_out')}}</td>
                        <td class="w100">
                          {{
                            getStatus(
                              "payoutTypeList",
                              item.payment_out,
                              "name"
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.list.table.fields.status')}}</td>
                        <td class="w100">
                          <v-chip
                            label
                            :text-color="getStatusBids(item.status, 'text')"
                            :color="getStatusBids(item.status, 'color')"
                          >
                            {{ getStatusBids(item.status, "name") }}
                          </v-chip>
                        </td>
                      </tr>
                      <tr v-if="item.transaction">
                        <td class="nowrap">{{$t('pagesSplitBids.list.table.fields.payment_type')}}</td>
                        <td class="w100">
                          {{
                            getTransactionParams(
                              item.transaction.type,
                              "type",
                              "name"
                            )
                          }}
                        </td>
                      </tr>
                      <!-- if decline -->
                      <tr v-if="item.status == 5">
                        <td class="nowrap"></td>
                        <td class="w100">
                          <span class="red--text">{{
                            item.params.comment
                          }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="block grid-list-lg mt-4" v-if="!loading && !errors">
              <h2>{{$t('pagesSplitBids.view.sectionBase.title')}}</h2>
              <div>
                <div v-if="item">
                  <table class="table-noborder">
                    <tbody>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.view.sectionBase.full_name')}}</td>
                        <td class="w100">
                          {{ item.user.full_name }}
                        </td>
                      </tr>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.view.sectionBase.birthday')}}</td>
                        <td class="w100">
                          {{ item.info.birthday | formatDate }}
                        </td>
                      </tr>
                    
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.view.sectionBase.email')}}</td>
                        <td class="w100">
                          {{ item.user.email }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="block grid-list-lg mt-4" v-if="!loading && !errors">
              <h2>{{$t('pagesSplitBids.view.passport.title')}}</h2>
              <div>
                <div v-if="item">
                  <table class="table-noborder">
                    <tbody>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.view.passport.seriaAndNumber')}}</td>
                        <td class="w100">
                          {{ item.info.passport_seria }}
                          {{ item.info.passport_number }}
                        </td>
                      </tr>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.view.passport.passportDate')}}</td>
                        <td class="w100">
                          {{ item.info.passport_date | formatDate }}
                        </td>
                      </tr>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.view.passport.who')}}</td>
                        <td class="w100">
                          {{ item.info.passport_who }}
                        </td>
                      </tr>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.view.passport.code')}}</td>
                        <td class="w100">
                          {{ item.info.passport_code }}
                        </td>
                      </tr>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.view.passport.scanFirstPage')}}</td>
                        <td class="w100">
                          <div v-if="getPhonePassportType(1)">
                            <a
                              href="#"
                              @click.prevent="
                                onFileStorage(getPhonePassportType(1))
                              "
                              >{{ getPhonePassportType(1).name }}</a
                            >
                          </div>
                          <div v-else>
                            <span class="red--text">{{$t('pagesSplitBids.view.passport.noPhoto')}}</span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.view.passport.scanSecondPage')}}</td>
                        <td class="w100">
                          <div v-if="getPhonePassportType(2)">
                            <a
                              href="#"
                              @click.prevent="
                                onFileStorage(getPhonePassportType(2))
                              "
                              >{{ getPhonePassportType(2).name }}</a
                            >
                          </div>
                          <div v-else>
                            <span class="red--text">{{$t('pagesSplitBids.view.passport.noPhoto')}}</span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="block grid-list-lg mt-4" v-if="!loading && !errors">
              <h2>{{$t('pagesSplitBids.view.address.title')}}</h2>
              <div>
                <div v-if="item">
                  <table class="table-noborder">
                    <tbody>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.view.address.region')}}</td>
                        <td class="w100">
                          {{ item.info.address_region }}
                        </td>
                      </tr>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.view.address.city')}}</td>
                        <td class="w100">
                          {{ item.info.address_city }}
                        </td>
                      </tr>
                      <tr>
                        <td class="nowrap">{{$t('pagesSplitBids.view.address.street')}}</td>
                        <td class="w100">
                          {{ item.info.address_street }}
                        </td>
                      </tr>
                      <tr>
                        <td class="nowrap"> {{ $t('pagesSplitBids.view.address.home') }} </td>
                        <td class="w100">
                          {{ item.info.address_home }}
                        </td>
                      </tr>
                      <tr>
                        <td class="nowrap"> {{ $t('pagesSplitBids.view.address.k') }} </td>
                        <td class="w100">
                          {{ item.info.address_k }}
                        </td>
                      </tr>
                      <tr>
                        <td class="nowrap"> {{ $t('pagesSplitBids.view.address.flat') }}</td>
                        <td class="w100">
                          {{ item.info.address_flat }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="block grid-list-lg mt-4" v-if="!loading && !errors">
              <h2>{{ $t('pagesSplitBids.view.generatedDocuments') }}</h2>
              <div>
                <div v-if="item">
                  <table class="table-noborder">
                    <tbody>
                      <tr
                        v-for="document in generatedDocuments"
                        :key="document.id"
                      >
                        <td class="w100">
                          <a
                            href="#"
                            @click.prevent="onFileStorage(document.file)"
                            >{{ document.file.name }}</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>

        <v-layout v-if="isShowActionPanel">
          <v-flex xs12 pt-0>
            <div class="block">
              <v-flex xs12 py-0 mb-5>
                <v-flex xs12 py-0 mb-5>
                  <v-divider />
                </v-flex>
                <v-flex xs12 py-0>
                  <!-- <v-btn
                    class="mr-2"
                    :loading="loading"
                    :disabled="loading"
                    color="green"
                    dark
                    x-large
                    @click="openVerifieldModal()"
                    >{{ $t('pagesSplitBids.view.actions.verified') }}</v-btn
                  >

                  <v-btn
                    class="mr-2"
                    color="deep orange"
                    dark
                    x-large
                    :loading="loading"
                    :disabled="loading"
                    @click="openNotVerifieldModal()"
                    >{{ $t('pagesSplitBids.view.actions.noVerified') }}</v-btn
                  > -->

                  <v-btn
                    color="red"
                    dark
                    x-large
                    @click="openBlockModal()"
                    :loading="loading"
                    :disabled="loading"
                    >{{ $t('pagesSplitBids.view.actions.decline') }}</v-btn
                  >

                  <v-btn
                    v-if="item.status == 10"
                    class="mx-2"
                    :loading="loading"
                    :disabled="loading"
                    color="green"
                    dark
                    x-large
                    @click="openChangeStatus(20)"
                    >{{ $t('pagesSplitBids.view.actions.goToPayment') }}</v-btn
                  >

                  <v-btn
                    v-if="isForceClientToPayedStatus"
                    class="mx-2"
                    :loading="loading"
                    :disabled="loading"
                    color="green"
                    dark
                    x-large
                    @click="openChangeStatus(40)"
                    >{{ $t('pagesSplitBids.view.actions.paymentComplete') }}</v-btn
                  >

                  <v-btn
                    v-if="item.status == 40"
                    class="mx-2"
                    :loading="loading"
                    :disabled="loading"
                    color="green"
                    dark
                    x-large
                    @click="openChangeStatus(100)"
                    >{{ $t('pagesSplitBids.view.actions.complete') }}</v-btn
                  >
                </v-flex>

                <v-flex xs12 py-0 my-5>
                  <v-divider />
                </v-flex>
              </v-flex>
            </div>
          </v-flex>
        </v-layout>

        <v-layout v-if="item && item.payment">
          <v-flex xs12 pt-0>
            <div class="block">
              <h2>{{ $t('pagesSplitBids.view.graphic.title') }}</h2>
              <table class="v-data-table graphic-payment-table">
                <thead class="v-data-table-header">
                  <th>{{ $t('pagesSplitBids.view.graphic.table.period') }}</th>
                  <th>{{ $t('pagesSplitBids.view.graphic.table.sum') }}</th>
                  <th>{{ $t('pagesSplitBids.view.graphic.table.bonus') }}</th>
                  <th>{{ $t('pagesSplitBids.view.graphic.table.ndfl') }}</th>
                  <th>{{ $t('pagesSplitBids.view.graphic.table.onpayment') }}</th>
                  <th>{{ $t('pagesSplitBids.view.graphic.table.status') }}</th>
                </thead>
                <tbody>
                  <tr v-for="pitem in item.payment.items" :key="pitem.id">
                    <td>{{ pitem.period | formatDate }}</td>
                    <td>{{ pitem.price | formatPrice }}</td>
                    <td>{{ pitem.bonus | formatPrice }}</td>
                    <td>{{ pitem.ndfl | formatPrice }}</td>
                    <td>{{ pitem.clear_price | formatPrice }}</td>
                    <td>{{ pitem.status }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <th colspan="2">{{ $t('pagesSplitBids.view.graphic.table.calcSumm') }}</th>
                  <th>{{ item.payment.bonus | formatPrice(null, 2) }}</th>
                  <th>{{ item.payment.ndfl | formatPrice(null, 2) }}</th>
                  <th>{{ item.payment.clear_price | formatPrice(null, 2) }}</th>
                  <th></th>
                </tfoot>
              </table>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="commentModal.show" max-width="600px" persistent>
      <v-layout row wrap modal__block>
        <span class="modal__close" @click="closeBlockModal"></span>
        <v-flex xs12 modal__wrapper pt-10 style="min-height: 400px">
          <v-flex shrink>
            <v-textarea
              v-model="commentModal.comment"
              outlined
              :label="$t('pagesSplitBids.view.declineModal.label')"
              pl2aceholder="$t('pagesSplitBids.view.declineModal.placeholder')"
              class="show-modal-comment pa-2"
            ></v-textarea>
          </v-flex>
          <v-btn
            class="mt-5"
            :loading="commentModal.loading"
            @click="onChangeStatus"
            :disabled="!commentModal.comment"
            x-large
            style="color: white"
            color="red"
            >{{ $t('pagesSplitBids.view.declineModal.submit') }}</v-btn
          >
        </v-flex>
      </v-layout>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { apiCallTrue } from "@/utils/api";
import showNotify from "@/services/noty";
import formatDateTime from "@/mixins/filters/formatDateTime";
import formatDate from "@/mixins/filters/formatDate";
import formatPhone from "@/mixins/filters/formatPhone";
import formatPrice from "@/mixins/filters/formatPrice";
import statusNames from "@/utils/data/statuses";

export default {
  name: "SplitListView",
  mixins: [formatDateTime, formatDate, formatPhone, formatPrice],
  data: () => ({
    errors: null,
    id: "",
    chat_id: "",
    loading: true,
    item: null,
    statusNames,

    commentModal: {
      show: false,
      comment: null,
      status: null,
      loading: false,
    },
  }),
  methods: {
    async onFileStorage(file) {
      await apiCallTrue({
        url: `v1/files/storage-link/${file.hash_id}`,
      }).then((response) => {
        Object.assign(document.createElement("a"), {
          target: "_blank",
          href: response.data.data,
        }).click();
      });
    },
    async onChangeStatus() {
      this.commentModal.loading = true;
      this.errors = null;
      await apiCallTrue({
        url: `v1/split/change-status`,
        method: "POST",
        data: {
          comment: this.commentModal.comment,
          status: this.commentModal.status,
        },
        params: {
          id: this.id,
        },
      })
        .then((response) => {
          console.log("RESP", response);
          this.closeBlockModal();
          // this.getLead();
        })
        .catch((error) => {
          showNotify("error", error);
        })
        .finally(() => {
          this.commentModal.loading = false;
        });
    },
    async openChangeStatus(status, comment = null) {
      this.__clearModalVariable();
      this.loading = true;
      await apiCallTrue({
        url: `v1/split/change-status`,
        method: "POST",
        data: {
          status: status,
          comment: comment,
        },
        params: {
          id: this.id,
        },
      })
        .then((response) => {
          console.log("RESP", response);
        })
        .catch((error) => {
          showNotify("error", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    __clearModalVariable() {
      this.commentModal.status = null;
      this.commentModal.comment = null;
      this.commentModal.loading = false;
    },
    closeBlockModal() {
      this.commentModal.show = false;
      this.__clearModalVariable();
    },

    openBlockModal() {
      this.__clearModalVariable();
      this.commentModal.show = true;
      this.commentModal.status = 5;
    },

    getTransactionParams(id, rootName, param) {
      const rootEl = this.statusNames.split["transaction"];
      if (rootEl && rootEl[rootName] && rootEl[rootName][id]) {
        return rootEl[rootName] && rootEl[rootName][id][param];
      }
      return null;
    },
    getStatusBids(id, param) {
      return this.statusNames.split.statuses.bids[id][param]
        ? this.statusNames.split.statuses.bids[id][param]
        : "";
    },
    getStatus(rootName, id, param) {
      return this.statusNames.split[rootName][id][param]
        ? this.statusNames.split[rootName][id][param]
        : "";
    },
    async getSplitBid() {
      this.item = null;
      this.loading = true;
      this.errors = null;
      await apiCallTrue({
        url: `v1/split/view`,
        params: { id: this.id },
      })
        .then((response) => {
          this.item = response.data.data;
        })
        .catch((error) => {
          showNotify("error", error);
          this.errors = error.message;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getSocketMessage(message) {
      switch (message.type) {
        case 2:
          if (
            message.action === "updateSplitBids" &&
            parseInt(message.data) === parseInt(this.id)
          ) {
            this.getSplitBid();
          }
          break;
      }
    },

    getPhonePassportType(type) {
      if (this.item && this.item.documents) {
        for (let p in this.item.documents) {
          if (this.item.documents[p].type == type)
            return this.item.documents[p].file;
        }
      }
      return null;
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getSplitBid();
  },
  components: {},
  watch: {
    wSocket(message) {
      this.getSocketMessage(message);
    },
  },
  computed: {
    ...mapState({
      userId: (state) => state.user.profile.id,
      wSocket: (state) => state.wSocket.message,
    }),

    isForceClientToPayedStatus() {
      if (this.item.status == 30) {
        if(this.item.transaction && this.item.transaction.type != 1)
          return false;
        return true;
      }

      return false;
    },

    isShowActionPanel() {
      if (!this.item) return false;
      if (this.item.status == 100) return false;
      if (this.item.status == 10) return true;
      if (this.item.status == 5) return false;
      if (this.item.status == 40) return false;
      return true;
    },

    generatedDocuments() {
      if (!this.item) return [];

      if (this.item.status == 10) return [];

      if (!this.item.documents) return [];

      return this.item.documents.filter((val) => {
        return val.type == 3 || val.type == 4;
      });
    },
  },
};
</script>
<style lang="scss">
table.graphic-payment-table {
  > thead {
    > th {
      background-color: #54638e;
      color: white;
    }
  }
  > tbody {
    > tr:nth-child(2n-1) {
      background-color: #f1f1f1;
    }
    > tr {
      cursor: pointer;
      &:hover {
        background: #fafafa;
      }
    }
  }

  > tfoot {
    border-top: 2px solid #54638e;
    font-weight: bold;
  }
}
</style>